import React, { FC } from 'react';
import { Question } from '../../data/questionnaireData';
import { BlackTick } from '../../icons/questionnaire/BlackTick';
import { RightChevron } from '../../icons/questionnaire/RightChevron';

interface QuestionCardProps {
    question: Question;
    onSelect: (questionNumber: number, riskPoints: number) => void;
    selectedOptionId: string | null;
}

const QuestionCard: FC<QuestionCardProps> = ({ question, onSelect, selectedOptionId }) => {
    const isFirstQuestion = question.id === 1;
    return (
        <div className="bg-white w-full max-w-2xl mx-auto pb-[100px]">
            <div className="text-13 font-medium text-blue30 mb-2 px-4">{question.id} of 4</div>
            <h2 className="text-[22px] font-medium text-gray-800 mb-9 leading-[1.3] px-4">{question.questionText}</h2>
            <div className="">
                {question.options.map((option, idx) => (
                    <div
                        key={option.id}
                        className={`flex items-center p-5 ${idx == 0 ? 'border-b border-t' : 'border-b'} cursor-pointer transition-all`}
                        onClick={() => {
                            onSelect(question.id, option.riskPoints);
                        }}
                    >
                        <div className="flex-grow flex items-center">
                            <span className="text-blue-600 mr-4 text-2xl">
                                {option.icon && typeof option.icon === 'function' ?
                                    React.createElement(option.icon) :
                                    option.icon
                                }
                            </span>
                            <div>
                                <p className="font-medium text-sm text-gray-800">{option.text}</p>
                                <p className="text-13 text-gray-500">{option.subText}</p>
                                {(selectedOptionId === option.id && option.details) && (
                                    <div className="mt-2 text-xs">
                                        <p className="text-13 text-gray-600">
                                            <span className="">Average returns:</span> <span className="font-medium text-black">{option.details.averageReturns}</span>
                                        </p>
                                        <p className="text-13 text-gray-600">
                                            <span className="">Worst & best case:</span> <span className="text-red-600">{option.details.worstCase}</span> to <span className="text-green-600">{option.details.bestCase}</span>
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {!isFirstQuestion ? (
                            <div className="flex-shrink-0"><RightChevron /></div>
                        ) : (
                            <div
                                className={`h-5 w-5 rounded-full border flex-shrink-0`}
                            >
                                {selectedOptionId === option.id && (
                                    <BlackTick />
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuestionCard;